export const api = [
  {
    _id: "604fa4b606c6966914383be3",
    title: "The Lean Startup",
    price: 24.34,
    image:
      "https://images-na.ssl-images-amazon.com/images/I/51T-sMqSMiL._SX329_BO_.jpg",
    rating: 5,
  },
  {
    _id: "604fa4b606c6966914383be4",
    title:
      "Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beat...",
    price: 239,
    image:
      "https://images-na.ssl-images-amazon.com/images/I/81O%2BGNdkzKL._AC_SX450_.jpg",
    rating: 4,
  },
  {
    _id: "604fa4b606c6966914383be5",
    title: "Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor",
    price: 199.99,
    image:
      "https://images-na.ssl-images-amazon.com/images/I/71Swqqe7XAL._AC_SX466_.jpg",
    rating: 3,
  },
  {
    _id: "604fa4b606c6966914383be6",
    title:
      "Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabr...",
    price: 98.99,
    image:
      "https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$",
    rating: 5,
  },
  {
    _id: "604fa4b606c6966914383be7",
    title:
      "New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)",
    price: 598.98,
    image:
      "https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg",
    rating: 3,
  },
  {
    _id: "604fa4b606c6966914383be8",
    title:
      "Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wid...",
    price: 1094.98,
    image:
      "https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg",
    rating: 5,
  },
];
